import keyBy from 'lodash/keyBy'
import { RootState } from 'types'

type State = RootState['reviews']

export default function reduce(state: State = {}, { type, payload }: any): State {
  switch (type) {
    case 'UPSERT_INFORMAL_FEEDBACK_REQUESTS': {
      const { informalFeedbackRequests } = payload
      return { ...state, ...keyBy(informalFeedbackRequests, (s) => s.id) }
    }
    case 'UPSERT_INFORMAL_FEEDBACK_REQUEST': {
      const { informalFeedbackRequest } = payload
      return { ...state, [informalFeedbackRequest.id]: informalFeedbackRequest }
    }
    default:
      return state
  }
}
